import { loadImage } from './helpers';
import lightboxInit from './lightbox';

// const ITEMS_TO_SHOW = 6;

const $ = window.jQuery;
const Modernizr = window.Modernizr;

const { open, close, changeHTML } = lightboxInit();

// probably should move to something more general
//===================================================================

const prefixes = [
	'media',
	'musician',
	'latest-news',
	'services',
];

const data = {
	default: {
		ITEMS_TO_SHOW: 6,
	},
	services: {
		ITEMS_TO_SHOW: 3,
	}
};


const defaultLoader = (obj) => {
	const { prefix, noVisible, ITEMS_TO_SHOW } = obj;
	return new Promise((resolve, reject) => {
		const startPoint = noVisible - 1;
		const toShow = $(`.${prefix}__item`).slice(startPoint, startPoint + (ITEMS_TO_SHOW + 1));
		resolve(toShow);
	});
};

const mediaLoader = (obj) => {
	return defaultLoader(obj); // temp
};

// returns true if there are items left to load
const defaultLeft = ({ prefix, noVisible:previousNoVisible, ITEMS_TO_SHOW }) => { // async as might have to query in the media one?
	return new Promise((resolve, reject) => {
		const $items = $(`.${prefix}__item`);
		resolve($items.length > previousNoVisible + ITEMS_TO_SHOW);
	});
};

const mediaLeft = (obj) => {
	// return defaultLeft();
	return defaultLeft(obj); // temp
};



const init = ({ prefix, getElementsToLoad, anyLeftToLoad }) => {
	const ITEMS_TO_SHOW = data[prefix] && data[prefix].ITEMS_TO_SHOW || data.default.ITEMS_TO_SHOW;
	const $item = $(`.${prefix}__item:not(.${prefix}__item--hidden)`);
	const $loadMore = $(`.${prefix}__load-more`);

	const loadMediaImages = function LOADMEDIAIMAGES() {
		const $this = $(this);
		const isLoading = $this.attr('data-is-loading'); // will be "true" if is loading or loaded
		if (isLoading === 'true') return;
		if ($this.hasClass(`${prefix}__item--no-pic`)) return; // don't load has no pic
		const $img = $this.find(`.${prefix}__item__image`);
		if ($img.length === 0) return; // should be a soundcloud media item

		const src = $img.attr('data-src');
		const alt = $img.attr('alt');

		$this.attr('data-is-loading', 'true');

		if ($this.hasClass(`${prefix}__item--hidden`)) $this.removeClass(`${prefix}__item--hidden`); // used with default loader


		loadImage(src)
			.then(() => {
				if (Modernizr.objectfit) {
					$img.attr('src', src);
				} else {
					const $div = $(`<div class="${prefix}__item__image ${prefix}__item__image--background"></div>`);
					$div.attr('role', 'image'); // accesibility stuff
					$div.attr('aria-label', alt);
					$div.css('background-image', `url('${src}')`);
					$img.replaceWith($div);
				}
			})
			.catch((err) => {
				console.log('Error loading image');
			});
	};
	if ($item.length !== 0) {
		$item.each(loadMediaImages);
	}

	if ($loadMore.length !== 0) {
		$loadMore.on('click', function() {
			const noVisible = $(`.${prefix}__item:not(.${prefix}__item--hidden)`).length;
			$loadMore[0].disabled = true;
			getElementsToLoad({
				prefix,
				noVisible,
				ITEMS_TO_SHOW
			})
			// getElementsToLoad('hey')
			.then(($toShow) => {
				$loadMore[0].disabled = false;
				// loadMediaImages($toShow);
				anyLeftToLoad({prefix, noVisible, ITEMS_TO_SHOW})
					.then((ret) => {
						if (ret === false) $loadMore.css('display', 'none');
					});
				$toShow.each(loadMediaImages);
			})
			.catch((err) => {
				console.log('Error with load more', err);
			});
		});
	}
};

prefixes.forEach((prefix) => {
	const getElementsToLoad = prefix === 'media' ? mediaLoader : defaultLoader;
	const anyLeftToLoad = prefix === 'media' ? mediaLeft : defaultLeft;
	init({
		prefix,
		getElementsToLoad,
		anyLeftToLoad,
	});
});

//===================================================================

const $mediaImage = $('.media__item--image');
if ($mediaImage.length !== 0) {
	let currentMediaImage = false;
	$(document).on('touchstart', (e) => {
		if (window.matchMedia('(max-width:48em)').matches) {
			const $target = $(e.target);
			const $parent = $target.parents('.media__item--image');
			const $el = $target.hasClass('media__item--image') ? $target : $parent;

			if (currentMediaImage) {
				currentMediaImage.removeClass('media__item--image--open');
				currentMediaImage = false;
			}
			if ($el.length !== 0) {
				$el.addClass('media__item--image--open');
				currentMediaImage = $el;
			}

		}
	});
}

const $musicianItem = $('.musician__item');
if ($musicianItem.length !== 0) {
	let currentMediaImage = false;
	$(document).on('touchstart', (e) => {
		if (window.matchMedia('(max-width:48em)').matches) {
			const $target = $(e.target);
			const $parent = $target.parents('.musician__item');
			const $el = $target.hasClass('musician__item') ? $target : $parent;

			if (currentMediaImage) {
				currentMediaImage.removeClass('musician__item--open');
				currentMediaImage = false;
			}
			if ($el.length !== 0) {
				$el.addClass('musician__item--open');
				currentMediaImage = $el;
			}

		}
	});
}
